"use client"

import { useParams } from "react-router-dom"
import { useMemo } from "react"

import styled from "styled-components"
import ConsultForm from '../../components/customer/ConsultForm';
import { getServiceData } from '../../components/customer/ConsultList';
import CustomerHead from '../../components/customer/CustomerHead';

export default function ConsultType() {
  const params = useParams()
  const type = params?.type


  const serviceData = useMemo(() => {
    const data = getServiceData(type)
    return data
  }, [type])

  return (
    <ConsultWrap>
      <CustomerHead title='Services Consult' back={true}/>
      <main className="content">
        <div className="consult-content">
          <ConsultForm />
          <div className="consult-space">
            <strong>{serviceData.title}</strong>
            <div className="space-content">
              <div className="space-img">
                <img src={serviceData.image || "/placeholder.svg"} alt={serviceData.title} />
              </div>
              <p>{serviceData.desc}</p>
            </div>
          </div>
        </div>
      </main>
    </ConsultWrap>
  )
}

const ConsultWrap = styled.section`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px 20px 80px 20px;

    .consult-content {
      position:relative;
      padding:50px;
      background:#0072B9;
      border-radius:30px;
      display:flex;
      gap:0 30px;

      .consult-space {
        position:relative;
        flex:1;
        padding:100px 50px;
        background:#fff;
        border-radius:30px;

        strong {
          font-weight:700;
          font-size:2rem;
          color:#000;
        }

        .space-content {
          position:relative;
          margin-top:30px;
          text-align: center;

          .space-img {
            position:relative;
            width:100%;

            img {
              width:100%;
            }
          }

          p {
            margin-top:25px;
            display:block;
            font-weight:400;
            font-size:1.2rem;
            line-height:1.5;
            color:#000;
          }
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      .consult-content {
        padding:25px 20px;
        border-radius:30px;
        flex-direction: column;
        gap:30px 0;

        .consult-space {
          padding:40px 20px;
          text-align:center;

          strong {
            font-size:2rem;
          }

          .space-content {
            margin-top:20px;
            text-align: left;

            p {
              margin-top:15px;
              font-size:1rem;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 640px) {
      .consult-content {

        .consult-space {

          strong {
            font-size:1.5rem;
          }
        }
      }
    }
  }
`